// extracted by mini-css-extract-plugin
export default {"loginwithButton":"loginwithbutton_loginwithButton__7yeAt"};